/* ══════════════════════════════════════════════════════════════════════════════
   MR. BUBBLES — I CORIANDOLI DELLA FESTA · 28/08/2026
   Va in `assets/mb-festa.js` del tema e viene caricato da `theme.liquid`, quindi
   vale su TUTTO il sito. Sorgente su Drive: 06_SITO_SHOPIFY/mb-festa.js.

   ⚠️ PERCHE' STA NEL TEMA E NON IN UN BLOCCO DELLA HOME. Al primo giro (23:20) i
   coriandoli erano dentro il Custom Liquid della home, perche' l'unica occasione
   era l'iscrizione alla newsletter, che sta li'. Poi Matteo ne ha chiesta una
   seconda — il primo articolo nel carrello — e quella succede quasi sempre su una
   SCHEDA PRODOTTO. Un blocco della home li' non c'e'. Quindi: un file solo, un
   motore solo, due occasioni.

   DUE OCCASIONI, e nessuna delle due e' un caso:
   1. ISCRIZIONE ALLA NEWSLETTER riuscita. Il form del tema non e' in AJAX: al
      successo Shopify ricarica la pagina con `?customer_posted=true` in coda.
      Quel parametro e' il segnale (e' di Shopify, non una nostra invenzione).
      ⚠️ Subito dopo l'indirizzo si RIPULISCE, se no un F5 rifarebbe la festa.
      Il «Grazie» resta: lo stampa il tema al momento del render.
   2. OGNI ARTICOLO NUOVO NEL CARRELLO (13/09, Matteo: prima era solo il primo).
      Se si riaggiunge un prodotto gia' aggiunto in questa visita, niente festa.

   COME SI CAPISCE CHE C'E' STATA UN'AGGIUNTA — e perche' non si guarda l'evento del tema.
   Il tema emette `cart:added` sul suo `eventBus`, ma la RUOTA della home fa
   l'aggiunta per conto suo (`mb-vassoio.liquid`: POST a /cart/add.js + drawer via
   eventBus) e quell'evento NON lo emette. Ascoltarlo vorrebbe dire perdere
   proprio la strada che si prova per prima. Quindi si guarda `fetch` verso
   `/cart/add`, che le prende tutte e due senza toccare nessun altro file.
   ⚠️ La toppa su `fetch` e' scritta per non poter rompere niente: si tiene
   l'originale, si restituisce la SUA promessa intatta, non si legge mai il corpo
   della risposta (leggerlo lo consumerebbe e il tema resterebbe a mani vuote), e
   tutto sta dentro un try/catch.

   Quali prodotti sono gia' stati aggiunti sta in `sessionStorage`: vedi OCCASIONE 2.

   COSTA ZERO QUANDO NON SERVE: nessun canvas, nessun ciclo, nessun elemento in
   pagina finche' non succede una delle due cose. Alla fine il canvas SI CANCELLA
   da solo — l'ultimo coriandolo che esce dal fondo spegne il ciclo e toglie
   l'elemento dal DOM.

   CHI HA CHIESTO MENO MOVIMENTO NON VEDE NIENTE (`prefers-reduced-motion`): gli
   restano il «Grazie» e il carrello, che dicono la stessa cosa senza far volare
   nulla.
   ══════════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var CALMO = window.matchMedia &&
              window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ════════════════════════════════════════════════════════════════════════
     IL MOTORE
     ════════════════════════════════════════════════════════════════════════ */
  var inCorso = false;

  /* `conBuste` distingue le due occasioni, ed e' l'unica differenza fra loro.
     Le buste sono il simbolo della NEWSLETTER — le stesse che volano in
     filigrana sulla sua card — e servono a far capire che la festa e' per la
     mail. Sul carrello non c'entrano niente: li' cadono solo coriandoli e
     stelle filanti. (Rilievo di Matteo, 28/08: al primo giro cadevano buste
     anche sull'aggiunta al carrello.) */
  function festa(conBuste) {
    if (CALMO || inCorso) return false;
    inCorso = true;

    /* ── tavolozza ─────────────────────────────────────────────────────── */
    /* gli stessi cinque della card eventi. L'inchiostro e' raro: su fondo crema
       un coriandolo quasi nero pesa il triplo degli altri. */
    var COLORI = ['#DCB12D', '#DCB12D', '#037fa2', '#05587e', '#571C27'];
    var PESI   = [ 6,         5,         4,         2,         1 ];
    var TOT = 0, ci;
    for (ci = 0; ci < PESI.length; ci++) TOT += PESI[ci];
    function colore() {
      var t = Math.random() * TOT, i;
      for (i = 0; i < PESI.length; i++) { t -= PESI[i]; if (t <= 0) return COLORI[i]; }
      return COLORI[0];
    }

    var W = window.innerWidth, H = window.innerHeight;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);

    var tela = document.createElement('canvas');
    tela.setAttribute('aria-hidden', 'true');
    /* ⚠️ appeso al <body> e a nient'altro: un genitore con `transform`
       romperebbe il `fixed` e i coriandoli scorrerebbero via con la pagina. */
    tela.style.cssText = 'position:fixed;inset:0;z-index:2147483000;pointer-events:none';
    var ctx = tela.getContext('2d');

    function misura() {
      W = window.innerWidth; H = window.innerHeight;
      tela.width = Math.round(W * dpr); tela.height = Math.round(H * dpr);
      tela.style.width = W + 'px'; tela.style.height = H + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    misura();
    window.addEventListener('resize', misura);
    document.body.appendChild(tela);

    /* ── quanti ────────────────────────────────────────────────────────── */
    /* proporzionale alla larghezza: ~170 su un desktop, ~68 su un telefono. Lo
       stesso numero su 390px sarebbe una coltre, non una festa. */
    var fattore = Math.max(0.45, Math.min(1.15, W / 1280));
    var pezzi = [];

    /* quanto e' alta la finestra rispetto a uno schermo normale. Serve solo a
       tenere la festa lunga uguale ovunque: su un monitor da 1600px di altezza,
       senza questo, i pezzi lenti ci metterebbero il doppio e a chiudere sarebbe
       la rete di sicurezza. */
    var altezza = Math.max(1, H / 900);

    function nascita(sopra) {
      var s = 0.55 + Math.random() * 0.8;            /* la profondita': un numero solo */
      var vicino = (s - 0.55) / 0.8;                 /* la stessa, portata a 0..1 */
      var d = Math.random();
      /* busta · striscia · coriandolo. Senza buste quel 15% passa ai CORIANDOLI,
         non alle strisce: le stelle filanti restano un quarto in tutti e due i
         casi, cosi' cambia cosa cade ma non il carattere della festa. */
      var tipo = conBuste ? (d < 0.15 ? 2 : (d < 0.40 ? 1 : 0))
                          : (d < 0.25 ? 1 : 0);
      var w, h;
      if (tipo === 2)      { w = (17 + Math.random() * 9) * s;   h = w * 0.66; }
      else if (tipo === 1) { w = (3 + Math.random() * 2.4) * s;  h = (16 + Math.random() * 14) * s; }
      else                 { w = (7 + Math.random() * 9) * s;    h = w * (0.45 + Math.random() * 0.55); }
      return {
        x: Math.random() * W,
        y: -30 - Math.random() * 170 - sopra,        /* il ritardo e' spazio, non un
                                                        timer: un pezzo piu' in alto
                                                        arriva dopo, e non serve
                                                        nessun contatore */
        vx: (Math.random() - 0.5) * 190,
        vy: 60 + Math.random() * 150,
        /* ⚠️ LA VELOCITA' LIMITE HA UN PAVIMENTO, e non e' pignoleria. Se la si fa
           solo proporzionale alla profondita', il pezzo piu' lontano cade a 80
           px/s: partito 500px sopra il bordo ci mette DIECI SECONDI ad
           attraversare, e a chiudere la festa finisce per essere la rete di
           sicurezza invece dell'ultimo coriandolo. Con questo pavimento il grosso
           e' a terra in ~4s e gli ultimi entro 7, che e' quanto dura una festa. */
        vTerm: (200 + vicino * 180 + Math.random() * 70) * altezza,
        w: w, h: h, tipo: tipo, col: colore(),
        rot: Math.random() * 6.28, vrot: (Math.random() - 0.5) * 7,
        fase: Math.random() * 6.28, vfase: 2.2 + Math.random() * 3.4,
        onda: (26 + Math.random() * 62) * s,         /* quanto sbanda di lato */
        ondaW: 0.9 + Math.random() * 1.5,
        alpha: 0.58 + 0.42 * vicino,
        morto: false
      };
    }

    /* DUE ONDATE, e non una pioggia uniforme. La prima e' fitta e arriva subito —
       i primi coriandoli entrano dopo ~0,2s, cioe' si vede una risposta al gesto;
       la seconda nasce 340px piu' in alto, cosi' quando la prima e' a meta'
       schermo il cielo non e' gia' vuoto. Poi basta: e' una festa, non un meteo. */
    var i;
    for (i = 0; i < Math.round(95 * fattore); i++) pezzi.push(nascita(0));
    for (i = 0; i < Math.round(55 * fattore); i++) pezzi.push(nascita(340));

    /* ── disegno di un pezzo ───────────────────────────────────────────── */
    var CREMA = '#FEF8F1';
    function disegna(p) {
      /* lo svolazzo: schiaccio la Y per fingere la rotazione sull'asse
         orizzontale. E' la stessa finta dei coriandoli della card eventi. */
      var schiaccia = Math.cos(p.fase);
      var lato = schiaccia < 0 ? 0.6 : 1;            /* il rovescio, in ombra */
      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rot);
      ctx.scale(1, Math.max(0.1, Math.abs(schiaccia)));
      ctx.globalAlpha = p.alpha * lato;
      ctx.fillStyle = p.col;
      if (p.tipo === 2) {
        var w = p.w, h = p.h;
        ctx.fillRect(-w / 2, -h / 2, w, h);
        ctx.strokeStyle = CREMA;
        ctx.lineWidth = Math.max(1, w * 0.075);
        ctx.lineJoin = 'round';
        ctx.beginPath();                             /* la V della patella */
        ctx.moveTo(-w / 2, -h / 2);
        ctx.lineTo(0, h * 0.06);
        ctx.lineTo(w / 2, -h / 2);
        ctx.stroke();
        ctx.strokeRect(-w / 2, -h / 2, w, h);
      } else {
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
      }
      ctx.restore();
    }

    /* ── il ciclo, che FINISCE ─────────────────────────────────────────── */
    var G = 900;                                     /* px/s² */
    var prima = 0, nato = -1, richiesta = 0;
    var LIMITE = 11000;                              /* rete di sicurezza: dopo 11s
                                                        si smonta comunque tutto */

    function chiudi() {
      if (richiesta) cancelAnimationFrame(richiesta);
      richiesta = 0;
      window.removeEventListener('resize', misura);
      if (tela.parentNode) tela.parentNode.removeChild(tela);
      inCorso = false;
    }

    function fotogramma(ora) {
      if (nato < 0) { nato = ora; prima = ora; }
      /* dt tagliato a 1/30: se la scheda va in secondo piano e torna, il salto
         sparerebbe tutti i coriandoli sotto lo schermo in un fotogramma solo. */
      var dt = Math.min((ora - prima) / 1000, 1 / 30);
      prima = ora;
      var t = (ora - nato) / 1000;

      ctx.clearRect(0, 0, W, H);
      var vivi = 0;
      for (var j = 0; j < pezzi.length; j++) {
        var p = pezzi[j];
        if (p.morto) continue;
        p.vy += G * dt;
        if (p.vy > p.vTerm) p.vy = p.vTerm;           /* l'aria: la carta non
                                                         accelera all'infinito */
        /* la velocita' laterale INSEGUE l'onda invece di essere l'onda: cosi' il
           pezzo sbanda come un foglio e non oscilla come un pendolo. */
        var bersaglio = Math.sin(t * p.ondaW + p.fase) * p.onda;
        p.vx += (bersaglio - p.vx) * Math.min(1, 2.6 * dt);
        p.x += p.vx * dt;
        p.y += p.vy * dt;
        p.rot += p.vrot * dt;
        p.fase += p.vfase * dt;
        if (p.y - Math.max(p.w, p.h) > H) { p.morto = true; continue; }
        vivi++;
        disegna(p);      /* fuori a destra o a sinistra si disegna lo stesso:
                            l'onda li fa rientrare da soli */
      }

      if (!vivi || ora - nato > LIMITE) { chiudi(); return; }
      richiesta = requestAnimationFrame(fotogramma);
    }
    richiesta = requestAnimationFrame(fotogramma);
    return true;                                     /* la festa e' partita davvero */
  }

  /* ════════════════════════════════════════════════════════════════════════
     OCCASIONE 1 — l'iscrizione alla newsletter e' andata a buon fine
     ════════════════════════════════════════════════════════════════════════ */
  if (/[?&]customer_posted=true(&|$)/.test(window.location.search)) {
    /* l'indirizzo si ripulisce SEMPRE, anche se poi non si anima niente: serve a
       non rifare la festa al primo F5. */
    try {
      var pulito = window.location.pathname +
        window.location.search
          .replace(/([?&])customer_posted=true(&|$)/, '$1')
          .replace(/[?&]$/, '') +
        window.location.hash;
      if (window.history && history.replaceState) history.replaceState(null, '', pulito);
    } catch (e) {}
    /* con le buste: qui la festa e' per la mail, e le buste lo dicono */
    var conBuste = function () { festa(true); };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', conBuste);
    } else {
      conBuste();
    }
  }

  /* ════════════════════════════════════════════════════════════════════════
     OCCASIONE 2 — ogni articolo nuovo che finisce nel carrello (13/09)
     ════════════════════════════════════════════════════════════════════════ */
  /* Matteo, 13/09: «ogni volta che si aggiunge al carrello, non solo la prima; l'unica
     restrizione: se si aggiunge lo stesso prodotto, niente coriandoli». Si ricordano le
     VARIANTI gia' aggiunte in questa visita (sessionStorage, e la memoria della pagina se
     sessionStorage non c'e') e la festa parte solo per una nuova. L'id si legge dal CORPO
     DELLA RICHIESTA — stringa form della ruota, FormData del tema, JSON — mai dalla risposta.
     Id illeggibile = festa lo stesso: meglio una festa in piu' che un'aggiunta muta. */
  var CHIAVE = 'mb-festa-aggiunti';
  var aggiunti = [];
  try { aggiunti = JSON.parse(sessionStorage.getItem(CHIAVE)) || []; } catch (e) {}

  function idDa(init) {
    try {
      var b = init && init.body;
      if (!b) return '';
      if (typeof FormData !== 'undefined' && b instanceof FormData) return String(b.get('id') || '');
      if (typeof b === 'string' && b.charAt(0) === '{') {
        var j = JSON.parse(b);
        return String(j.id || (j.items && j.items[0] && j.items[0].id) || '');
      }
      return String(new URLSearchParams(b).get('id') || '');   /* stringa form o URLSearchParams */
    } catch (e) { return ''; }
  }

  var fetchVero = window.fetch;
  if (typeof fetchVero === 'function') {
    window.fetch = function (risorsa, init) {
      var promessa = fetchVero.apply(this, arguments);
      try {
        var url = String((risorsa && risorsa.url) || risorsa || '');
        if (url.indexOf('/cart/add') !== -1) {
          var id = idDa(init);
          promessa.then(function (r) {
            if (!r || !r.ok) return;
            if (id && aggiunti.indexOf(id) !== -1) return;  /* stesso prodotto: niente festa */
            /* mezzo secondo di ritardo: il tema apre il suo cassetto del carrello
               subito dopo, e le due cose insieme sull'istante si accavallano.
               SENZA buste: quelle sono della newsletter. */
            setTimeout(function () {
              /* la variante si ricorda SOLO se la festa parte davvero (rilievo della review,
                 13/09): con due aggiunte diverse di fila la seconda cade durante la festa
                 della prima, e se venisse segnata non festeggerebbe mai piu'. */
              if (festa(false) && id) {
                aggiunti.push(id);
                try { sessionStorage.setItem(CHIAVE, JSON.stringify(aggiunti)); } catch (e) {}
              }
            }, 480);
          })['catch'](function () {});
          /* ⚠️ questo `.then` e' una diramazione: la promessa restituita al tema
             resta `promessa`, intatta. E il corpo della risposta non si legge
             MAI, perche' leggerlo lo consumerebbe e il tema lo troverebbe vuoto. */
        }
      } catch (e) {}
      return promessa;
    };
  }
})();
